import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center min-h-[80vh] w-full">
      <img 
        src="/public/img/loading.png" 
        alt="Loading..." 
        className="w-auto h-auto max-w-[300px] max-h-[300px] object-contain"
      />
    </div>
  );
}